import Label from '@ubnt/ui-components/Label/Label';
import Text from '@ubnt/ui-components/Text/Text';
import InfoIndicator from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import Slider, { SliderProps } from '@ubnt/ui-components/Slider/Slider';
import { useMemo } from 'react';

import { Flex } from 'components/Flex';
import { useTooltipWidth } from 'hooks/useTooltipWidth';

import classes from './ChannelUsageSlider.module.scss';

export interface ChannelUsageSliderProps extends Omit<SliderProps, 'forwardedRef'> {
  value: number;
}

const ChannelUsageSlider = ({ label, ...restProps }: ChannelUsageSliderProps) => {
  const segmentLabels = useMemo(() => ['Low', 'High'], []);
  const tooltipWidth = useTooltipWidth();

  return (
    <Slider
      formatValueIndicatorContent={(value) => <Text className={classes.valueIndicator}>{value}%</Text>}
      label={
        <Flex gap="xs" alignCenter>
          <Label color="tertiary">{label}</Label>
          <InfoIndicator severity="info2" tooltipWidth={tooltipWidth} maxWidth={tooltipWidth}>
            Level of interference or noise on the Wi-Fi channel. High channel usage may lead to slower performance and
            reduced reliability due to increased interference from other devices or networks.
          </InfoIndicator>
        </Flex>
      }
      segmentLabels={segmentLabels}
      segments={1}
      contentClassName={classes.content}
      valueIndicatorPosition="right"
      variant="secondary"
      withValueIndicator
      data-vaul-no-drag
      {...restProps}
    />
  );
};

export default ChannelUsageSlider;
